import styled from "styled-components"

export interface StyledCourseProps {
  degree: string
}
export interface StyledCourseProgramsProps {
  programs_count: number
}

export const StyledCourse = styled.div<StyledCourseProps>`
  background: ${props => props.theme.colors.white};
  box-shadow: 0 4px 8px ${(props) => props.theme.colors.darkGrey15};
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    display: flex;
    justify-content: space-between;
    border-left: 6px solid;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    border-top: 6px solid;
  }
  ${props => props.degree === "bba" && (`
    border-color: ${props.theme.colors.undergraduate} !important;
  `)}
  ${props => props.degree === "mba" && (`
    border-color: ${props.theme.colors.mba} !important; 
  `)}
  ${props => props.degree === "msc" && (`
    border-color: ${props.theme.colors.masters} !important;
  `)}
`
export const StyledCourseMain = styled.div`
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 32px;
    min-width: 70%;
    max-width: 70%;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
    width: 100%%;
  }
`
export const StyledCourseLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & p{
    ${(props) => props.theme.mixins.label};
    color: ${(props) => props.theme.colors.darkGrey60};
    margin-bottom: 8px;
  }
`
export const StyledCourseTitle = styled.p`
  ${(props) => props.theme.mixins.subsectionTitle};
`
export const StyledCourseDescription = styled.div`
  margin: 16px 0 0;

  & p {
    ${(props) => props.theme.mixins.body}

    & a{
      ${(props) => props.theme.mixins.link}  
    }
    & strong{
      ${(props) => props.theme.mixins.bold}  
    }
  }
`
export const StyledCoursePrograms = styled.p<StyledCourseProgramsProps>`
  ${(props) => props.theme.mixins.body}
  margin: 16px 0 0;

  ${props => props.programs_count > 1 && (`
    & span {
      &:after{
        content: ", "
      }
      &:nth-last-of-type(2){
        &:after{
          display: none;
        }
      }
      &:nth-last-of-type(1){
        &:after{
          display: none;
        }
        &:before{
          content: " and "
        }
      }
    }
  `)}
  & a{
    ${(props) => props.theme.mixins.link}
  }
`

export const StyledCourseTopics = styled.div`
  background: ${props => props.theme.colors.darkGrey05};

  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 32px;
    min-width: 30%;
    max-width: 30%;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
    width: 100%%;
  }
`

